module.exports = __webpack_public_path__ + "assets/lessons/pl/lesson2/modals/lesson_2_2_a.pdf";